import React from 'react';
import { WixPatternsDashboardTestProvider } from './CairoDashboardTestProvider';
import { CairoProviderProps } from './CairoDashboardBaseProvider';
import { WixPatternsDashboardProviderInternal } from './CairoDashboardProviderInternal';

export function WixPatternsProviderInternal(props: CairoProviderProps) {
  if (process.env.NODE_ENV === 'test') {
    return <WixPatternsDashboardTestProvider {...props} />;
  }

  return <WixPatternsDashboardProviderInternal {...props} />;
}
